<div class="funnel-shell">
  <header class="funnel-shell__header">
    <img class="funnel-shell__brand" src="/assets/funnel/fac3less.svg" alt="FAC3LESS" />
    <div class="funnel-shell__lang-switch" role="group" aria-label="Language">
      @for (lang of languages; track lang.code) {
        <button
          type="button"
          class="funnel-shell__lang-btn"
          [class.is-active]="lang.code === currentLang()"
          (click)="switchLanguage(lang.code)"
        >{{ lang.label }}</button>
      }
    </div>
  </header>

  <div class="funnel-shell__content">
    <ng-content />
  </div>

  <div class="funnel-shell__legal">
    <a class="funnel-shell__legal-link" (click)="openPolicy('privacy_policy')">
      {{ 'policy.privacy' | translate }}
    </a>
    <a class="funnel-shell__legal-link" (click)="openPolicy('terms_of_service')">
      {{ 'policy.tos' | translate }}
    </a>
    <a class="funnel-shell__legal-link" (click)="openPolicy('legal_notice')">
      {{ 'policy.legalNotice' | translate }}
    </a>
  </div>

  @if (footerText(); as footerText) {
    <div class="funnel-shell__operator">
      <span [innerHtml]="footerText | safeHtml"></span>
    </div>
  }
</div>

<c-offcanvas
  placement="end"
  [visible]="policyVisible()"
  (visibleChange)="policyVisibleChange($event)"
>
  <c-offcanvas-header>
    <button
      type="button"
      class="btn-close ms-auto"
      aria-label="Close"
      (click)="closePolicy()"
    ></button>
  </c-offcanvas-header>
  <c-offcanvas-body>
    @if (policyLoading()) {
      <p>Loading…</p>
    } @else {
      <consent [content]="policyContent()"></consent>
    }
  </c-offcanvas-body>
</c-offcanvas>
